import type { U3129InitLUPersonalization } from '../U3129Service';
import { u2000SkipHourBankBalanceValidationOnSubmit } from '../../u2000Core/tools/u2000SkipHourBankBalanceValidationOnSubmit';

/** BL-0606 : personnalisation org legacy — pas de blocage UI soldes banques à la soumission. */
export function u3129SkipHourBankBalanceValidationOnSubmit(
  personalization?: U3129InitLUPersonalization | null,
): boolean {
  return u2000SkipHourBankBalanceValidationOnSubmit(personalization);
}
